/* import __COLOCATED_TEMPLATE__ from './completed.hbs'; */
/* RESPONSIBLE TEAM: team-knowledge-foundations */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import type truncateHelper from 'embercom/helpers/truncate-string';

interface Signature {
  Args: {
    notification: {
      data: {
        externalContentUrl: string;
        sourceUrl: string;
        ctaUrl: string;
        folderId?: number;
        contentName?: string;
      };
    };
  };
}

export default class Completed extends Component<Signature> {
  @service declare knowledgeHubService: $TSFixMe;

  @action
  handleGoToFolderPage(folderId: number) {
    this.knowledgeHubService.goToFolder(folderId);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Notifications::ContentImport::Completed': typeof Completed;
    truncate: typeof truncateHelper;
  }
}
